module.exports = __webpack_public_path__ + "img/8.da89493c.jpg";